import { render, staticRenderFns } from "./contentsListPage.vue?vue&type=template&id=cdfee20a&"
import script from "./contentsListPage.vue?vue&type=script&lang=ts&"
export * from "./contentsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports